import { db } from "../../services/firebase";
import {
  doc,
  setDoc,
  collection,
  updateDoc,
  arrayUnion
} from "firebase/firestore";

export async function addEstablishmentClient(establishmentData) {
  const docRef = doc(collection(db, "services"));
  await setDoc(docRef, establishmentData);
  return { serviceId: docRef.id };
}

export async function saveServiceDetailsClient({ serviceId, type, details, currentRegion, serviceDetails }) {
  const serviceRef = doc(db, "services", serviceId);
  
  if (type === 'offerings') {
    await updateDoc(serviceRef, {
      offerings: arrayUnion(details)
    });
  } else if (type === 'storeCategory') {
    await updateDoc(serviceRef, {
      storeCategories: arrayUnion(details)
    });
  } else if (type === 'categoryItem') {
    const { categoryIndex, items } = details;
    const updatedCategories = [...serviceDetails.storeCategories];
    
    if (!updatedCategories[categoryIndex]) {
      throw new Error('Category not found');
    }
    
    if (!updatedCategories[categoryIndex].itemsByRegion) {
      updatedCategories[categoryIndex].itemsByRegion = {};
    }
    
    if (!updatedCategories[categoryIndex].itemsByRegion[currentRegion]) {
      updatedCategories[categoryIndex].itemsByRegion[currentRegion] = [];
    }
    
    updatedCategories[categoryIndex].itemsByRegion[currentRegion] = [
      ...updatedCategories[categoryIndex].itemsByRegion[currentRegion],
      ...items
    ];
    
    await updateDoc(serviceRef, {
      storeCategories: updatedCategories
    });
  }
}